import React, { useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Redirect } from "react-router";
import {
  useFormDetailsActions,
  useFormDetailsState,
} from "../context/FormDetailsContext";
import { isInternal } from "../helpers";
import AuthPage from "./hoc/AuthPage";
import { useWatch } from "react-hook-form";
import { useOffices } from "../adapters/uplist";
import { CreditCard } from "../components/fields";

const NoPayment = () => {
  return (
    <div className="flex-grow-1 d-flex flex-column align-items-center justify-content-center">
      <h1>No Payment Option Selected</h1>
      <h2>
        We will need to contact the agent for payment info before we can
        complete the job.
      </h2>
    </div>
  );
};

const InvoiceOffice = ({ office }) => {
  return (
    <div className="flex-grow-1 d-flex flex-column align-items-center justify-content-center">
      <h1>Great!</h1>
      <h2>
        Once your appointment is completed we will send the invoice to{" "}
        {office.name}.
      </h2>
    </div>
  );
};

const SelectPaymentOption = ({ office, setChargeType }) => {
  return (
    <div className="flex-grow-1 d-flex flex-column justify-content-center">
      <Row>
        {office.invoiceable && (
          <>
            <Col xs={12}>
              <h2>
                We have a billing agreement setup with {office.name}. Would you
                like us to send invoices to your office for payment or provide a
                credit card?
              </h2>
            </Col>
            <Col>
              <Button
                onClick={() => setChargeType(2)}
                className="h-100"
                block
                size="lg"
              >
                Invoice {office.name}
              </Button>
            </Col>
          </>
        )}
        <Col>
          <Button
            onClick={() => setChargeType(3)}
            className="h-100"
            block
            size="lg"
          >
            Provide a Credit Card
          </Button>
        </Col>
      </Row>
    </div>
  );
};

const InternalPaymentLinks = ({ charge_type, setChargeType }) => {
  if (!isInternal()) return null;
  return (
    <>
      {![0, 2].includes(charge_type) && (
        <p>
          <span className="text-link" onClick={() => setChargeType(0)}>
            Continue without selecting a payment option.
          </span>
          <span>(not-recommended)</span>
        </p>
      )}
      {![null, undefined].includes(charge_type) && (
        <p>
          <span className="text-link" onClick={() => setChargeType(null)}>
            Select a different payment option.
          </span>
        </p>
      )}
    </>
  );
};

const PaymentInfoPage = () => {
  const office_id = useWatch({ name: "office_id" });
  const { isRealtor, charge_type } = useFormDetailsState();
  const { setInfo } = useFormDetailsActions();
  const { data: offices } = useOffices();
  const office = offices?.find((office) => office.id === office_id) || {};
  const { invoiceable } = office;
  useEffect(() => {
    setInfo({
      charge_type: isRealtor === false || invoiceable === false ? 3 : null,
    });
  }, [isRealtor, invoiceable, setInfo]);
  if (isRealtor === undefined && !isInternal()) {
    return (
      <Redirect
        to={{
          pathname: "/signup",
          state: { noAnimate: true },
        }}
      />
    );
  }

  const setChargeType = (charge_type) => setInfo({ charge_type });
  let PaymentOption;

  switch (charge_type) {
    case 0:
      PaymentOption = NoPayment;
      break;
    case 2:
      PaymentOption = InvoiceOffice;
      break;
    case 3:
      PaymentOption = CreditCard;
      break;
    default:
      PaymentOption = SelectPaymentOption;
      break;
  }
  return (
    <AuthPage>
      <PaymentOption office={office} setChargeType={setChargeType} />
      <InternalPaymentLinks
        charge_type={charge_type}
        setChargeType={setChargeType}
      />
    </AuthPage>
  );
};

export default PaymentInfoPage;
